import { Directive, Input } from "@angular/core";

@Directive()
export class CellRendererDirective {
  @Input() rawValue: any;
  @Input() rowIndex?: number;
  @Input() row: any;
}
